var input = document.getElementById('placesAutocomplete');
if(input !== null) {
    var autocomplete = new google.maps.places.Autocomplete(input, {
        componentRestrictions: {country: 'GB'}
    });

    autocomplete.addListener('place_changed', function() {
        var place = autocomplete.getPlace();
        var placeIdInput = document.getElementById('placeIdInput');
        if (place && place.place_id && placeIdInput) {
            placeIdInput.value = place.place_id;
        }
    });
}
